import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@apollo/client";

import SimpleModal from "../../../components/common/SimpleModal";
import CountryForm from "./form/RoomForm";
import {
  setBugForm,
  setUpdateRoom,
  toggleBugModal,
  toggleRoomModal,
} from "../redux/roomSlice";
import { DELETE_ROOM } from "../../../graphql/mutations/management";
import { FETCH_ROOMS } from "../../../graphql/queries/management";
import { CheckCircleIcon, CrossIcon } from "../../../constants/icon_path";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/common/CustomErrorMessage";

const RoomTable = ({ data }) => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector((state) => state.room);

  const handleEdit = (data) => {
    dispatch(
      setUpdateRoom({
        id: data.id,
        name: data.name,
        engName: data.engName,
        password: data.password,
        isRequirePassword: data.isRequirePassword,
        minimumBalance: data.minimumBalance,
        isRequireMinimumBalance: data.isRequireMinimumBalance,
      })
    );
    dispatch(toggleRoomModal());
  };

  const [deleteRoom] = useMutation(DELETE_ROOM, {
    refetchQueries: [{ query: FETCH_ROOMS }],
    onCompleted: ({ updateRoom }) => {
      if (updateRoom) {
        showSuccessToast();
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const renderBoolIcon = (bool) => {
    if (bool) {
      return <CheckCircleIcon size={25} color="green" />;
    } else {
      return <CrossIcon size={25} color="red" />;
    }
  };

  const handleClose = () => dispatch(toggleRoomModal());
  const handleDelete = (data) => {
    const answer = window.confirm("ຕ້ອງການລຶບບໍ?");
    if (answer) {
      deleteRoom({ variables: { id: data.id } });
    }
  };

  const handleOpenBug = (data) => {
    dispatch(setBugForm({ id: data.id, isBugOpen: data.isBugOpen }));
    dispatch(toggleBugModal());
  };

  return (
    <>
      <SimpleModal
        show={isOpenModal}
        handleClose={handleClose}
        title="ແກ້ໄຂຂໍ້ມູນເດີມພັນ"
        size="lg"
      >
        <CountryForm handleClose={handleClose} />
      </SimpleModal>
      <Table bordered responsive>
        <thead>
          <tr>
            <th className="text-center">
              <strong>#</strong>
            </th>
            <th className="text-center">
              <strong>ຊື່ຫ້ອງເກມ</strong>
            </th>
            <th className="text-center">
              <strong>ຊື່ພາສາອັງກິດ</strong>
            </th>
            <th className="text-center">
              <strong>ຕ້ອງການລະຫັດຫ້ອງເກມ</strong>
            </th>
            <th className="text-center">
              <strong>ລະຫັດຫ້ອງເກມ</strong>
            </th>
            <th className="text-center">
              <strong>ຕ້ອງໃສ່ເງິນຂັ້ນຕ່ຳ</strong>
            </th>
            <th className="text-center">
              <strong>ເງິນຂັ້ນຕ່ຳ</strong>
            </th>
            <th className="text-center">
              <strong>ເປີດ/ປິດບັກ</strong>
            </th>
            <th className="text-center">
              <strong>ແກ້ໄຂຂໍ້ມູນ</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((d, i) => {
            return (
              <tr key={d.id}>
                <td className="text-center">
                  <strong>{i + 1}</strong>
                </td>
                <td className="text-center">{d.name}</td>
                <td className="text-center"> {d.engName}</td>
                <td className="text-center">
                  {renderBoolIcon(d.isRequirePassword)}
                </td>
                <td className="text-center">{d?.password}</td>
                <td className="text-center">
                  {renderBoolIcon(d.isRequireMinimumBalance)}
                </td>
                <td className="text-center">{d?.minimumBalance}</td>
                <td className="text-center">{renderBoolIcon(d.isBugOpen)}</td>
                <td className="text-center" style={{ width: "300px" }}>
                  <div
                    className="btn btn-primary me-1"
                    onClick={() => handleOpenBug(d)}
                  >
                    ເປີດ/ປິດ ບັກ
                  </div>
                  <div
                    className="btn btn-primary shadow btn-xs sharp me-1"
                    onClick={() => handleEdit(d)}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </div>
                  <div
                    className="btn btn-danger shadow btn-xs sharp me-1"
                    onClick={() => handleDelete(d)}
                  >
                    <i className="fas fa-trash"></i>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default RoomTable;
